import React from "react";
import { Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import fullLogoWhite from "../../assets/images/png/logo2.png";
import './style.css';
import instagramIconBW from '../../assets/images/png/instagram_bw.png';
import facebookIconBW from '../../assets/images/png/facebookbw.png';
import tiktokIcon1 from '../../assets/images/png/tiktok_bw.png';
import { Tooltip } from 'react-tooltip';
import { useMediaQuery } from 'react-responsive';
import { FaPhone, FaMapMarkerAlt } from 'react-icons/fa';

export default function Footer() {


    const isMobile = useMediaQuery({ query: '(max-width: 768px)' });


    return (

        <footer className="footer-container">


            {!isMobile && (

                <div className="footer-content">

                    {/* Logo e Nome */}
                    <div className="footer-logo">
                        <Link to={"/welcome"}>
                            <img src={fullLogoWhite} alt="Logotipo" />
                        </Link>
                    </div>

                    {/* Endereço */}
                    <div className="footer-address">
                    <div className="mb-3 text-center">
                            <br></br>
                            <FaMapMarkerAlt className="me-2 text-primary" />
                            <strong>Endereço:</strong> Rua Conselheiro Quintiliano, 210<br></br>Ouro Preto, Minas Gerais
                            <br></br>
                            <br></br>
                            <FaPhone className="me-2 text-primary" />
                            <strong>Telefone:</strong> <a href="tel:+553133505046" className="text-primary">(31) 3350-5046</a>
                        </div>
                    </div>

                    {/* Redes sociais */}
                    <div className="footer-social">
                        <a href='https://www.instagram.com/repsemdestino/' data-tooltip-id="instagram-tooltip" data-tooltip-content="Acesse nosso Instagram!">
                            <img src={instagramIconBW} alt="Instagram" />
                            <Tooltip id="instagram-tooltip" />
                        </a>
                        <a href='https://www.facebook.com/RepublicaSemDestino/' data-tooltip-id="facebook-tooltip" data-tooltip-content="Acesse nosso Facebook!">
                            <img src={facebookIconBW} alt="Facebook" />
                            <Tooltip id="facebook-tooltip" />
                        </a>
                        <a href="https://www.tiktok.com/@repsemdestino" data-tooltip-id="tiktok-tooltip" data-tooltip-content="Acesse nosso TikTok!">
                            <img src={tiktokIcon1} alt="TikTok" />
                            <Tooltip id="tiktok-tooltip" />
                        </a>
                    </div>
                </div>
            )}
            {isMobile && (

                <div className="footer-content-mobile">

                    {/* Logo e Nome */}
                    <div className="footer-logo">
                        <Link to={"/welcome"}>
                            <img src={fullLogoWhite} alt="Logotipo" />
                        </Link>
                    </div>

                    {/* Endereço */}
                    <div className="footer-address-mobile">
                        <div className="mb-3 text-center">
                            <br></br>
                            <FaMapMarkerAlt className="me-2 text-primary" />
                            <strong>Endereço:</strong> Rua Conselheiro Quintiliano, 210<br></br>Ouro Preto, Minas Gerais
                            <br></br>
                            <br></br>
                            <FaPhone className="me-2 text-primary" />
                            <strong>Telefone:</strong> <a href="tel:+553133505046" className="text-primary">(31) 3350-5046</a>
                        </div>
                    </div>

                    {/* Redes sociais */}
                    <div className="footer-social-mobile">
                        <a href='https://www.instagram.com/repsemdestino/' data-tooltip-id="instagram-tooltip" data-tooltip-content="Acesse nosso Instagram!">
                            <img src={instagramIconBW} alt="Instagram" />
                            <Tooltip id="instagram-tooltip" />
                        </a>
                        <a href='https://www.facebook.com/RepublicaSemDestino/' data-tooltip-id="facebook-tooltip" data-tooltip-content="Acesse nosso Facebook!">
                            <img src={facebookIconBW} alt="Facebook" />
                            <Tooltip id="facebook-tooltip" />
                        </a>
                        <a href="https://www.tiktok.com/@repsemdestino" data-tooltip-id="tiktok-tooltip" data-tooltip-content="Acesse nosso TikTok!">
                            <img src={tiktokIcon1} alt="TikTok" />
                            <Tooltip id="tiktok-tooltip" />
                        </a>
                    </div>
                </div>
            )}




            {/* Linha separadora */}
            <hr className="footer-divider" />

            {/* Copyright */}
            <div className="footer-copyright">
                <p>© {new Date().getFullYear()} República Sem Destino. Todos os direitos reservados.</p>
            </div>
        </footer>
    );
}
